/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from antd/components/avatar/Group.tsx
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import { SizeContextProvider } from './SizeContext';
import { cloneElement } from '../_util/reactNode';
import toArray from 'rc-util/lib/Children/toArray';
import Avatar from './Avatar';
import { Popover } from '../popover';
const Group = (props) => {
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const { prefixCls: customizePrefixCls, className, size } = props;
    const { maxCount, maxStyle } = props;
    const prefixCls = getPrefixCls('avatar-group', customizePrefixCls);
    const newClassName = classNames(prefixCls, {
        [`${prefixCls}-xl`]: size === 'xl',
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className);
    const { children, maxPopoverPlacement = 'top' } = props;
    const childrenWithProps = toArray(children).map((child, index) => cloneElement(child, {
        key: `avatar-key-${index}`
    }));
    const numOfChildren = childrenWithProps.length;
    if (maxCount && maxCount < numOfChildren) {
        const childrenShow = childrenWithProps.slice(0, maxCount);
        const childrenHidden = childrenWithProps.slice(maxCount, numOfChildren);
        childrenShow.push(React.createElement(Popover, { key: 'avatar-popover-key', content: childrenHidden, trigger: 'hover', placement: maxPopoverPlacement, footer: false, overlayClassName: `${prefixCls}-popover` },
            React.createElement(Avatar, { style: maxStyle }, `+${numOfChildren - maxCount}`)));
        return (React.createElement(SizeContextProvider, { size: size },
            React.createElement("div", { className: newClassName, style: props.style }, childrenShow)));
    }
    return (React.createElement(SizeContextProvider, { size: size },
        React.createElement("div", { className: newClassName, style: props.style }, childrenWithProps)));
};
// export default withConfigProvider(Group);
export default Group;
